module.exports = __webpack_public_path__ + "img/aethir.a7b72aff.png";